import type { LC, LiveElement } from '@use-gpu/live';
import type { ShaderSource } from '@use-gpu/shader';

import { provide, yeet, useMemo } from '@use-gpu/live';

import { useShader, useNoShader } from '../hooks/useShader';
import { MaterialContext } from '../providers/material-provider';
import { QueueReconciler } from '../reconcilers/index';

import { getNormalMapSurface } from '@use-gpu/wgsl/instance/surface/normal-map-surface.wgsl';
import { getSolidSurface } from '@use-gpu/wgsl/instance/surface/solid-surface.wgsl';
import { getNormalFragment } from '@use-gpu/wgsl/instance/fragment/normal.wgsl';
import { getColor } from '@use-gpu/wgsl/mask/color.wgsl';

import { getRenderFunc } from '../hooks/useRenderProp';

const {signal} = QueueReconciler;

export type NormalMaterialProps = {
  normalMap?: ShaderSource,
  apply?: ShaderSource,

  render?: (material: Record<string, Record<string, ShaderSource | null | undefined | void>>) => LiveElement,
  children?: LiveElement | ((material: Record<string, Record<string, ShaderSource | null | undefined | void>>) => LiveElement),
};

export const NormalMaterial: LC<NormalMaterialProps> = (props: NormalMaterialProps) => {
  const {
    normalMap,
    apply,
    children,
  } = props;

  const getLight = useShader(getNormalFragment, [apply]);
  const getFragment = getColor;

  let getSurface = getSolidSurface;
  if (normalMap) getSurface = useShader(getNormalMapSurface, [getSurface, normalMap]);
  else useNoShader();

  const context = useMemo(() => ({
    solid: {
      getFragment,
    },
    shaded: {
      getFragment,
      getSurface,
      getLight,
    },
  }), [getSurface, getLight, getFragment]);

  const render = getRenderFunc(props);
  const view = render ? render(context) : children;
  return render ?? children ? provide(MaterialContext, context, [signal(), view]) : yeet(context);
};

